const startOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

const normalizeDate = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  parsed.setHours(0, 0, 0, 0);
  return parsed;
};

export const isOfferActive = (offer, today = startOfToday()) => {
  if (!offer) return false;
  if (!offer.validTill) return true;
  const expiry = normalizeDate(offer.validTill);
  if (!expiry) return false;
  return expiry >= today;
};

export const getActiveOffers = (offers = [], today = startOfToday()) => {
  if (!Array.isArray(offers)) return [];
  return offers.filter((offer) => isOfferActive(offer, today));
};
